import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import cx from 'classnames';

type ModulePageLayoutProps = {
    basePath: string;
    children: ReactNode;
    canManageSettings: boolean;
};

const tabClassName = (isActive: boolean) =>
    cx(
        'rounded-xl px-4 py-2 text-sm font-medium transition-all duration-150',
        isActive
            ? 'bg-white text-woodyBrown shadow-sm'
            : 'text-woodyBrown text-opacity-50 hover:bg-white hover:bg-opacity-50 hover:text-opacity-80',
    );

export const ModulePageLayout = ({
    basePath,
    children,
    canManageSettings,
}: ModulePageLayoutProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex h-full min-h-0 w-full flex-col text-woodyBrown">
            {canManageSettings && (
                <nav
                    className="mb-5 inline-flex w-fit shrink-0 items-center gap-1 rounded-2xl bg-woodyBrown bg-opacity-[0.06] p-1"
                    aria-label={t('modules.modulePages.navigationLabel')}
                >
                    <NavLink
                        exact
                        to={basePath}
                        className={tabClassName}
                        isActive={(_, location) =>
                            location.pathname === basePath
                        }
                    >
                        {t('modules.modulePages.main')}
                    </NavLink>
                    <NavLink
                        to={`${basePath}/settings`}
                        className={tabClassName}
                    >
                        {t('modules.modulePages.settings')}
                    </NavLink>
                </nav>
            )}
            <div className="min-h-0 flex-1">{children}</div>
        </div>
    );
};
